// Update this index when you add a new flag. it should always be the last number added
// Current index = 13

export enum FeatureFlag {
  CreateImageInteraction = 1,
  CreateFullPageTextInteraction = 2,
  CreateMultipleChoiceInteraction = 3,
  CreateFlipcardInteraction = 4,
  CreateAccordionInteraction = 5,
  CreateCarouselInteraction = 6,
  CreateSortationInteraction = 7,
  CreateMatchingInteraction = 8,
  CreateHotspotInteraction = 9,
  CreateFiveStarRatingInteraction = 10,
  AddESVGImage = 11,
  CreateResultsPageInteraction = 12,
  CreateClickAndRevealInteraction = 13,
  CreateTopicPortalInteraction = 14,
  UseMyFeedbackApp = 15,
}

export const isFeatureEnabled = (feature: FeatureFlag) => {
  switch (feature) {
    case FeatureFlag.CreateImageInteraction:
      return true;
    case FeatureFlag.CreateFullPageTextInteraction:
      return true;
    case FeatureFlag.CreateMultipleChoiceInteraction:
      return true;
    case FeatureFlag.CreateFlipcardInteraction:
      return true;
    case FeatureFlag.CreateAccordionInteraction:
      return true;
    case FeatureFlag.CreateCarouselInteraction:
      return true;
    case FeatureFlag.CreateSortationInteraction:
      return true;
    case FeatureFlag.CreateMatchingInteraction:
      return true;
    case FeatureFlag.CreateHotspotInteraction:
      return true;
    case FeatureFlag.CreateFiveStarRatingInteraction:
      return true;
    case FeatureFlag.AddESVGImage:
      return true;
    case FeatureFlag.CreateResultsPageInteraction:
      return true;
    case FeatureFlag.CreateClickAndRevealInteraction:
      return true;
    case FeatureFlag.CreateTopicPortalInteraction:
      return true;
    case FeatureFlag.UseMyFeedbackApp:
      return true;
  }
};

enum InteractionType {
  Image = 1,
  FullPageText = 2,
  MultipleChoice = 3,
  Flipcard = 4,
  Accordion = 5,
  Carousel = 6,
  Sortation = 7,
  Matching = 8,
  Hotspot = 9,
  FiveStarRating = 10,
  AddESVGImage = 11,
  ResultsPage = 12,
  ClickAndReveal = 13,
  TopicPortal = 14,
  UseMyFeedbackApp = 15,
}

const interactionTypeList = Object.keys(InteractionType)
  .filter(key => typeof InteractionType[key] === 'number')
  .map(key => InteractionType[key]);

const toCreateFlag = (interactionType: InteractionType): FeatureFlag => {
  switch (interactionType) {
    case InteractionType.Image:
      return FeatureFlag.CreateImageInteraction;
    case InteractionType.FullPageText:
      return FeatureFlag.CreateFullPageTextInteraction;
    case InteractionType.MultipleChoice:
      return FeatureFlag.CreateMultipleChoiceInteraction;
    case InteractionType.Flipcard:
      return FeatureFlag.CreateFlipcardInteraction;
    case InteractionType.Accordion:
      return FeatureFlag.CreateAccordionInteraction;
    case InteractionType.Carousel:
      return FeatureFlag.CreateCarouselInteraction;
    case InteractionType.Sortation:
      return FeatureFlag.CreateSortationInteraction;
    case InteractionType.Matching:
      return FeatureFlag.CreateMatchingInteraction;
    case InteractionType.Hotspot:
      return FeatureFlag.CreateHotspotInteraction;
    case InteractionType.FiveStarRating:
      return FeatureFlag.CreateFiveStarRatingInteraction;
    case InteractionType.ResultsPage:
      return FeatureFlag.CreateResultsPageInteraction;
    case InteractionType.ClickAndReveal:
      return FeatureFlag.CreateClickAndRevealInteraction;
    case InteractionType.TopicPortal:
      return FeatureFlag.CreateTopicPortalInteraction;
    case InteractionType.UseMyFeedbackApp:
      return FeatureFlag.UseMyFeedbackApp;
    default:
      return -1
  }
};

export const createableInteractions = interactionTypeList
  .map(toCreateFlag)
  .filter(isFeatureEnabled);
